import CoreDrawer from '@/components/CoreDrawer';
import { useCoreContext } from '@/core';
import { Spin } from 'antd';
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CourseTopicForm } from './CourseTopicForm';

interface Props {
  open: boolean;
  handleClose: () => void;
  setOpen: (value: boolean) => void;
}

export const DetailCourseTopic = (props: Props) => {
  const { open, setOpen, handleClose } = props;
  const { loadingDetail, errorDetail, detailCourseTopic, actionGetAllCourseTopic } =
    useCoreContext();

  const [currentQueryParameters] = useSearchParams();
  const showId = currentQueryParameters.get('id');
  const getAction = currentQueryParameters.get('action');

  useEffect(() => {
    if ((showId !== null && getAction === 'Detail') || getAction === 'Create') {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [showId, getAction, setOpen]);

  // Handler for successful form submission
  const handleFormSubmitSuccess = () => {
    // Refresh the course line list
    if (actionGetAllCourseTopic) {
      actionGetAllCourseTopic();
    }
    // Close the drawer
    handleClose();
  };

  const renderContent = () => {
    if (showId) {
      return (
        <>
          <div>{loadingDetail && <Spin />}</div>
          {errorDetail && <div>Error</div>}
          {!errorDetail && !loadingDetail && get(detailCourseTopic, 'id') !== '' && (
            <CourseTopicForm
              detailCourseTopic={detailCourseTopic}
              openForm={open}
              onFormSubmitSuccess={handleFormSubmitSuccess}
            />
          )}
        </>
      );
    }
    return (
      <CourseTopicForm
        detailCourseTopic={showId ? detailCourseTopic : null}
        openForm={open}
        onFormSubmitSuccess={handleFormSubmitSuccess}
      />
    );
  };

  return (
    <CoreDrawer
      open={open}
      onClose={() => handleClose()}
      content={renderContent()}
      bodyStyle={{ marginTop: '20px' }}
      title={showId ? 'Edit Course Line' : 'Create Course Line'}
    />
  );
};
